var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Filter",
                    "label-cols": "1",
                    "label-size": "sm",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: { size: "sm" },
                    model: {
                      value: _vm.filter,
                      callback: function ($$v) {
                        _vm.filter = $$v
                      },
                      expression: "filter",
                    },
                  }),
                ],
                1
              ),
              _c("b-table", {
                staticClass: "table-mini",
                attrs: {
                  bordered: "",
                  striped: "",
                  responsive: "",
                  items: _vm.item.columns || [],
                  fields: _vm.fields,
                  "show-empty": "",
                  filter: _vm.filter,
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(calculate_field)",
                    fn: function (row) {
                      return [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: row.item.calculate_field,
                              expression: "row.item.calculate_field",
                            },
                          ],
                          attrs: { type: "checkbox", disabled: "" },
                          domProps: {
                            checked: Array.isArray(row.item.calculate_field)
                              ? _vm._i(row.item.calculate_field, null) > -1
                              : row.item.calculate_field,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = row.item.calculate_field,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      row.item,
                                      "calculate_field",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      row.item,
                                      "calculate_field",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(row.item, "calculate_field", $$c)
                              }
                            },
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "cell(business_definition)",
                    fn: function (row) {
                      return [
                        _c("b-form-input", {
                          attrs: {
                            disabled: "",
                            size: "sm",
                            type: "text",
                            placeholder: "describe...",
                          },
                          model: {
                            value: row.item.business_definition,
                            callback: function ($$v) {
                              _vm.$set(row.item, "business_definition", $$v)
                            },
                            expression: "row.item.business_definition",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }